/**
 * Event Modal
 * @format
 */

import React, { useState } from 'react';
import ModalWrapper from '@components/modals/modal-wrapper';

interface ModalLinkProps {
  title?: string;
  linkText: string;
  content: string;
  modalLinkClasses: string;
}

/**
 * Modal Link
 */
const ModalLink = ({
  title,
  linkText,
  content,
  modalLinkClasses,
}: ModalLinkProps): JSX.Element => {
  const [showModal, setShowModal] = useState<boolean>(false);

  /**
   * Render.
   */
  return (
    <>
      <button
        type="button"
        className={`${modalLinkClasses} simple-modal-link`}
        onClick={() => setShowModal(true)}>
        {linkText}
      </button>

      <ModalWrapper showModal={showModal} setShowModal={setShowModal}>
        <>
          {title && <h3>{title}</h3>}
          {content && (
            <div
              className="simple-modal-content-container"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}
        </>
      </ModalWrapper>
    </>
  );
};
export default ModalLink;
